import type { GymFinderService } from 'app/features/leads/services/gym-finder/gym-finder-service';
import { LEADS_FIXTURES } from 'app/features/leads/services/gym-finder/fixtures/leads';
import type { LeadSummary, LeadsListParams, LeadsListResult } from 'app/features/leads/services/gym-finder/types';

const MOCK_DELAY_MS = 300;

type MockGymFinderServiceOptions = {
  shouldReject?: boolean;
  profileComplete?: boolean;
};

const filterLeads = (leads: LeadSummary[], params: LeadsListParams): LeadSummary[] => {
  const search = params.search.trim().toLowerCase();

  return leads
    .filter((lead) => {
      if (params.status !== 'all' && lead.status !== params.status) {
        return false;
      }
      if (!search) {
        return true;
      }
      return lead.athleteName.toLowerCase().includes(search) || lead.athleteEmail.toLowerCase().includes(search);
    })
    .sort((a, b) => new Date(b.receivedAt).getTime() - new Date(a.receivedAt).getTime());
};

export const createMockGymFinderService = (options: MockGymFinderServiceOptions = {}): GymFinderService => {
  const { shouldReject = false, profileComplete = true } = options;

  return {
    listLeads: async (params: LeadsListParams): Promise<LeadsListResult> => {
      await new Promise((resolve) => setTimeout(resolve, MOCK_DELAY_MS));

      if (shouldReject) {
        throw new Error('Failed to fetch leads');
      }

      const filtered = filterLeads(LEADS_FIXTURES, params);

      return {
        leads: filtered,
        totalCount: LEADS_FIXTURES.length,
        profileComplete,
      };
    },

    getLead: async (id: string): Promise<LeadSummary> => {
      await new Promise((resolve) => setTimeout(resolve, MOCK_DELAY_MS));

      if (shouldReject) {
        throw new Error('Failed to fetch lead');
      }

      const lead = LEADS_FIXTURES.find((item) => item.id === id);
      if (!lead) {
        throw new Error(`Lead not found: ${id}`);
      }

      return lead;
    },
  };
};

export const mockGymFinderService = createMockGymFinderService();
